var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('AddonPromo',{attrs:{"title":_vm.$t('common.sso'),"text":_vm.$t('addons.sso'),"image-src":"/images/sso-icon.svg"}})
}
var staticRenderFns = []

export { render, staticRenderFns }